# Assets Configuration

This section is where you configure settings for your Assets.

## Media Storage Location

The location on your hard drive or storage device of where you want to store any assets uploaded to CanvasPro.

## Asset Expire Time (in Days)

Changes the default expiry time of newly uploaded assets.
This doesn't affect current assets. The default setting is 100 Days until they expire.

import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';

export function AddButton() {
  return (
    <v-btn
      color="primary"
      variant="flat">
      Add
    </v-btn>
  );
}

export function EditButton() {
  return (
    <v-btn
      color="orange"
      variant="flat">
      Edit
    </v-btn>
  );
}

export function RemoveButton() {
  return (
    <v-btn
      color="red"
      variant="flat">
      Remove
    </v-btn>
  );
}

import SectionHelp from '../templates/SectionHelp.mdx';

# Ingest Locations Configuration

Ingest Locations are effectively Hot Folders, CanvasPro will watch the folder, and as assets are added it will add them and tag them according to the Ingest Location settings for that folder.

<SectionHelp />

## Add Ingest Locations

Click the <AddButton /> button, and fill in the fields, once you're done click <ExampleSaveButton />.

## Edit Ingest Locations

Click the <EditButton /> button and fill in the fields, once you're done click <ExampleSaveButton />.

## Remove Ingest Locations

{/* Editor note: */}
<v-alert
  icon="mdi-alert"
  color='warning'
  density='compact'
  title="Note"
  text="This instantly removes the Ingest Location without warning!"
/>

Click the <RemoveButton /> button.
